import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function CoinSkeleton({ cryptoId, isSmallScreen, leaderList }) {
  return (
    <div className="flex lg:mx-20 md:mx-10" style={{ flexDirection: "column" }}>
      <SkeletonTheme baseColor="#222938" highlightColor="#141924">
        {cryptoId && leaderList.length === 0 && (
          <div>
            <Skeleton height="4.5rem" width="4.5rem" borderRadius="50%" />
            <Skeleton className="mt-3 mb-8" width={70} />
          </div>
        )}
        <div className="mb-3">
          <Skeleton
            height={65}
            count={5}
            className="mb-3"
            width={isSmallScreen ? 350 : 700}
            borderRadius={10}
          />
        </div>
      </SkeletonTheme>
    </div>
  );
}

export default CoinSkeleton;
